<div class="menu-container">
    <app-canvas-design-options *ngIf="showCanvasOptions()" [selectedMimic]="selectedMimic" [rootList]="rootList">
    </app-canvas-design-options>

    <app-text-design-options
        *ngIf="showTextOptions()"
        [selectedElement]="selectedElements[0]"></app-text-design-options>

    <app-alignment-options *ngIf="showShapeOptions()" [selectedElements]="selectedElements"></app-alignment-options>
    <app-position-options *ngIf="showShapeOptions()" [selectedElements]="selectedElements"></app-position-options>
    <app-dimensions-options
        *ngIf="showShapeOptions() && !isGroup()"
        [selectedElements]="selectedElements"></app-dimensions-options>
    <app-object-orientation *ngIf="showShapeOptions()" [selectedElements]="selectedElements"></app-object-orientation>
    <app-corner-radius-options
        *ngIf="showCornerRadius()"
        [selectedElements]="selectedElements"></app-corner-radius-options>
    <app-rotation-options *ngIf="showShapeOptions()" [selectedElements]="selectedElements"></app-rotation-options>
    <app-appearance-options
        *ngIf="showShapeOptions() && !hideAppearanceOption()"
        [selectedElements]="selectedElements"></app-appearance-options>
</div>
